if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomScale = 1;
        this.panX = 0;
        this.panY = 0;
      }

      hide() {
        this.resetZoom();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindSwipeEvents();
        this.bindZoomEvents();
        this.bindNavButtons();
        this.buildThumbnailStrip();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.updateActiveThumb();
        this.resetZoom();
      }

      bindNavButtons() {
        if (this.navButtonsBound) return;
        this.navButtonsBound = true;

        const prevButton = this.querySelector('[data-modal-prev]');
        const nextButton = this.querySelector('[data-modal-next]');

        if (prevButton) prevButton.addEventListener('click', () => this.showAdjacentMedia(-1));
        if (nextButton) nextButton.addEventListener('click', () => this.showAdjacentMedia(1));
      }

      bindSwipeEvents() {
        if (this.swipeEventsBound) return;
        this.swipeEventsBound = true;

        const container = this.querySelector('[role="document"]');
        if (!container) return;

        let startX = 0;
        let startY = 0;
        let tracking = false;

        const onPointerDown = (event) => {
          if (this.zoomScale > 1) return;
          if (event.target.closest('deferred-media, product-model, button')) return;
          startX = event.clientX;
          startY = event.clientY;
          tracking = true;
        };

        const onPointerUp = (event) => {
          if (!tracking) return;
          tracking = false;
          if (this.zoomScale > 1) return;

          const deltaX = event.clientX - startX;
          const deltaY = event.clientY - startY;
          const swipeThreshold = 50;

          if (Math.abs(deltaX) > swipeThreshold && Math.abs(deltaX) > Math.abs(deltaY)) {
            event.stopPropagation();
            this.showAdjacentMedia(deltaX < 0 ? 1 : -1);
          }
        };

        container.addEventListener('pointerdown', onPointerDown);
        container.addEventListener('pointerup', onPointerUp);
      }

bindZoomEvents() {
        if (this.zoomEventsBound) return;
        this.zoomEventsBound = true;

        const container = this.querySelector('[role="document"]');
        if (!container) return;

        let pinchStartDistance = 0;
        let pinchStartScale = 1;
        let pinchOffsetX = 0;
        let pinchOffsetY = 0;
        let pinchStartPanX = 0;
        let pinchStartPanY = 0;
        let panStartX = 0;
        let panStartY = 0;
        let isPanning = false;

        let isDraggingMouse = false;
        let dragMoved = false;
        let dragStartX = 0;
        let dragStartY = 0;
        let dragStartPanX = 0;
        let dragStartPanY = 0;

        const getActiveImage = () => {
          const activeMedia = this.querySelector('[data-media-id].active');
          if (!activeMedia) return null;
          return activeMedia.tagName === 'IMG' ? activeMedia : activeMedia.querySelector('img');
        };

        const applyTransform = (img) => {
          if (!img) return;
          img.style.transform = `translate(${this.panX}px, ${this.panY}px) scale(${this.zoomScale})`;
        };

        const clampPan = (img) => {
          if (!img || this.zoomScale <= 1) {
            this.panX = 0;
            this.panY = 0;
            return;
          }
          const rect = img.getBoundingClientRect();
          const maxX = Math.max(0, (rect.width * this.zoomScale - rect.width) / 2);
          const maxY = Math.max(0, (rect.height * this.zoomScale - rect.height) / 2);
          this.panX = Math.min(maxX, Math.max(-maxX, this.panX));
          this.panY = Math.min(maxY, Math.max(-maxY, this.panY));
        };

        // Desktop: scroll or trackpad pinch to zoom
        container.addEventListener(
          'wheel',
          (event) => {
            event.preventDefault();
            const img = getActiveImage();
            if (!img) return;

            const delta = event.deltaY * -0.01;
            this.zoomScale = Math.min(4, Math.max(1, this.zoomScale + delta));
            clampPan(img);
            applyTransform(img);
            container.classList.toggle('is-zoomed', this.zoomScale > 1);
          },
          { passive: false }
        );

        // Click the image to zoom in toward that spot; click again to zoom back out
        container.addEventListener('click', (event) => {
          if (dragMoved) {
            dragMoved = false;
            return;
          }

          const img = getActiveImage();
          if (!img || event.target !== img) return;

          if (this.zoomScale > 1) {
            this.zoomScale = 1;
            this.panX = 0;
            this.panY = 0;
          } else {
            const rect = img.getBoundingClientRect();
            const offsetX = event.clientX - rect.left - rect.width / 2;
            const offsetY = event.clientY - rect.top - rect.height / 2;
            this.zoomScale = 2.5;
            this.panX = -offsetX * (this.zoomScale - 1);
            this.panY = -offsetY * (this.zoomScale - 1);
            clampPan(img);
          }
          applyTransform(img);
          container.classList.toggle('is-zoomed', this.zoomScale > 1);
        });

        // Desktop: click-and-drag to pan around while zoomed in
        container.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') return;
          const img = getActiveImage();
          if (!img || this.zoomScale <= 1 || event.target !== img) return;

          event.preventDefault();
          isDraggingMouse = true;
          dragMoved = false;
          dragStartX = event.clientX;
          dragStartY = event.clientY;
          dragStartPanX = this.panX;
          dragStartPanY = this.panY;
          container.classList.add('is-dragging');
        });

        // Stop the browser's native "drag this image" behavior from ever kicking in
        container.addEventListener('dragstart', (event) => event.preventDefault());

        container.addEventListener('pointermove', (event) => {
          if (!isDraggingMouse) return;
          const img = getActiveImage();
          if (!img) return;

          const deltaX = event.clientX - dragStartX;
          const deltaY = event.clientY - dragStartY;
          if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) dragMoved = true;

          this.panX = dragStartPanX + deltaX;
          this.panY = dragStartPanY + deltaY;
          clampPan(img);
          applyTransform(img);
        });

        const endMouseDrag = () => {
          if (!isDraggingMouse) return;
          isDraggingMouse = false;
          container.classList.remove('is-dragging');
        };

        container.addEventListener('pointerup', endMouseDrag);
        container.addEventListener('pointerleave', endMouseDrag);

        // Touch: pinch to zoom toward the pinch point + drag to pan while zoomed
        container.addEventListener(
          'touchstart',
          (event) => {
            const img = getActiveImage();
            if (!img) return;

            if (event.touches.length === 2) {
              const [t1, t2] = event.touches;
              pinchStartDistance = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
              pinchStartScale = this.zoomScale;
              pinchStartPanX = this.panX;
              pinchStartPanY = this.panY;

              const midX = (t1.clientX + t2.clientX) / 2;
              const midY = (t1.clientY + t2.clientY) / 2;
              const rect = img.getBoundingClientRect();
              const centerX = rect.left + rect.width / 2;
              const centerY = rect.top + rect.height / 2;
              pinchOffsetX = (midX - centerX) / this.zoomScale;
              pinchOffsetY = (midY - centerY) / this.zoomScale;
            } else if (event.touches.length === 1 && this.zoomScale > 1) {
              isPanning = true;
              panStartX = event.touches[0].clientX - this.panX;
              panStartY = event.touches[0].clientY - this.panY;
            }
          },
          { passive: true }
        );

        container.addEventListener(
          'touchmove',
          (event) => {
            const img = getActiveImage();
            if (!img) return;

            if (event.touches.length === 2 && pinchStartDistance > 0) {
              const [t1, t2] = event.touches;
              const distance = Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
              const newScale = Math.min(4, Math.max(1, pinchStartScale * (distance / pinchStartDistance)));

              this.panX = pinchStartPanX - pinchOffsetX * (newScale - pinchStartScale);
              this.panY = pinchStartPanY - pinchOffsetY * (newScale - pinchStartScale);
              this.zoomScale = newScale;

              clampPan(img);
              applyTransform(img);
              container.classList.toggle('is-zoomed', this.zoomScale > 1);
            } else if (isPanning && event.touches.length === 1) {
              this.panX = event.touches[0].clientX - panStartX;
              this.panY = event.touches[0].clientY - panStartY;
              clampPan(img);
              applyTransform(img);
            }
          },
          { passive: true }
        );

        container.addEventListener('touchend', (event) => {
          if (event.touches.length === 0) {
            pinchStartDistance = 0;
            isPanning = false;
            if (this.zoomScale <= 1.02) {
              this.resetZoom();
            }
          }
        });
      }

      resetZoom() {
        this.zoomScale = 1;
        this.panX = 0;
        this.panY = 0;
        const container = this.querySelector('[role="document"]');
        const activeMedia = this.querySelector('[data-media-id].active');
        const img = activeMedia ? (activeMedia.tagName === 'IMG' ? activeMedia : activeMedia.querySelector('img')) : null;
        if (img) img.style.transform = '';
        if (container) container.classList.remove('is-zoomed');
      }

      buildThumbnailStrip() {
        if (this.thumbStripBuilt) return;

        const thumbsContainer = this.querySelector('[data-media-thumbs]');
        const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        if (!thumbsContainer || mediaItems.length < 2) return;

        this.thumbStripBuilt = true;

        mediaItems.forEach((item, index) => {
          const sourceImg = item.tagName === 'IMG' ? item : item.querySelector('img');
          const thumb = document.createElement('button');
          thumb.type = 'button';
          thumb.className = 'product-media-modal__thumb';
          thumb.setAttribute('aria-label', `View image ${index + 1}`);

          if (sourceImg) {
            const thumbImg = document.createElement('img');
            thumbImg.src = sourceImg.src;
            thumbImg.alt = '';
            thumbImg.loading = 'lazy';
            thumb.appendChild(thumbImg);
          }

          thumb.addEventListener('click', () => this.showMediaAtIndex(index));
          thumbsContainer.appendChild(thumb);
        });

        this.updateActiveThumb();
      }

      showMediaAtIndex(index) {
        const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        if (index < 0 || index >= mediaItems.length) return;

        mediaItems.forEach((item) => item.classList.remove('active'));
        const nextMedia = mediaItems[index];
        nextMedia.classList.add('active');
        nextMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = 0;

        if (
          nextMedia.nodeName == 'DEFERRED-MEDIA' &&
          nextMedia.querySelector('template') &&
          nextMedia.querySelector('template').content.querySelector('.js-youtube')
        ) {
          nextMedia.loadContent();
        }

        window.pauseAllMedia();
        this.updateActiveThumb();
        this.resetZoom();
      }

      showAdjacentMedia(direction) {
        const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        if (mediaItems.length < 2) return;

        const currentIndex = mediaItems.findIndex((item) => item.classList.contains('active'));
        if (currentIndex === -1) return;

        let nextIndex = currentIndex + direction;
        if (nextIndex < 0) nextIndex = mediaItems.length - 1;
        if (nextIndex >= mediaItems.length) nextIndex = 0;

        this.showMediaAtIndex(nextIndex);
      }

      updateActiveThumb() {
        const mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));
        const currentIndex = mediaItems.findIndex((item) => item.classList.contains('active'));
        const thumbs = this.querySelectorAll('.product-media-modal__thumb');
        thumbs.forEach((thumb, index) => {
          thumb.classList.toggle('active', index === currentIndex);
        });
        const activeThumb = this.querySelector('.product-media-modal__thumb.active');
        if (activeThumb) activeThumb.scrollIntoView({ inline: 'center', block: 'nearest' });
      }
    }
  );
}